/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Moment from 'react-moment';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class ExtendProjectMultiSuccess extends React.Component<*> {
  componentDidMount() {
    const response: Object = this.props.response;

    const vToday: Date = new Date();
    const nEndDt: Date = new Date(response.end_date);
    vToday < nEndDt && this.props.projectDetailsStore.changeStatus('Active');
    // eslint-disable-next-line camelcase
    this.props.projectDetailsStore.details.end_date = response.end_date;
  }

  render(): React.Node {
    /*eslint-disable max-len*/

    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const response: Object = this.props.response;

    const newEndDate: Date = new Date(
      Math.max.apply(
        null,
        response.map(function(p) {
          return new Date(p.end_date);
        })
      )
    );

    const projectsExtended: Array<string> = response
      .map(r => `${r.code} - ${r.name}`)
      .map(project => <li key={project}>{project}</li>);

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.multiple_extended')}
          >
            {response && (
              <React.Fragment>
                <ul>{projectsExtended}</ul>
                <p>{t('general:projects.messages.multiple_extended')}</p>
              </React.Fragment>
            )}
            <h5>{t('general:labels.new_end_date')}:</h5>
            <p>{response && <Moment date={newEndDate} format="MMMM DD, YYYY" />}</p>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
